import React from 'react';
import { Link } from 'react-router-dom';
import './HeroSection.css';

function HeroSection({ title, subtitle, buttonText, buttonLink, backgroundImage }) {
  const heroStyle = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${backgroundImage})`,
  };

  return (
    <section className="hero-section" style={heroStyle}>
      <div className="container hero-content">
        <h1>{title}</h1>
        <p className="hero-subtitle">{subtitle}</p>
        <div className="hero-cta">
          <Link to={buttonLink} className="button hero-button">
            {buttonText}
          </Link>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
